import { render } from "./SubscriptionNews.vue?vue&type=template&id=262c927e&scoped=true"
import script from "./SubscriptionNews.vue?vue&type=script&lang=js"
export * from "./SubscriptionNews.vue?vue&type=script&lang=js"

import "./SubscriptionNews.vue?vue&type=style&index=0&id=262c927e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262c927e"]])

export default __exports__